import { convertToBase64 } from "./convertToBase64";
import { handlePhotoSubmit } from "./handlePhotoSubmit";

export async function handleFileInput(
  e,
  setState,
  State,
  Photo_Type,
  Photo_Group,
  Attendee_ID,
  User
) {
  const file = e.target.files[0];
  const base64 = await convertToBase64(file);
  setState({ ...State, myFile: base64 });
  handlePhotoSubmit(
    e,
    base64,
    Photo_Type,
    Photo_Group,
    Attendee_ID,
    setState,
    User
  );
}
